import { Route } from "@tanstack/react-router";
import HomePage, { searchParamsSchema } from "../pages/home";
import { rootRoute } from "./root";

export const homeRoute = new Route({
  validateSearch: (search) => searchParamsSchema.parse(search),
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});
